import React, { useState, useEffect } from 'react';
import { Box, Paper, InputLabel } from '@material-ui/core';
import InputBase from '@mui/material/InputBase';
import FileInputButton from '../fileInputButton';
import Typography from '../typography';
import commons from '../../../assets/styles/commons';
import colors from '../../../assets/styles/colors';

interface ImageUploadFieldProps {
  label: string;
  onChange: (file: File | null) => void;
  currentValue: File | string | null;
  error?: boolean;
  helperText?: string;
  acceptedFileTypes?: string;
  placeholder?: string;
}

const ImageUploadField: React.FC<ImageUploadFieldProps> = ({
  label,
  onChange,
  currentValue,
  error,
  helperText,
  acceptedFileTypes = 'image/*',
  placeholder = 'Anexe o arquivo aqui...',
}) => {
  const [displayedFileName, setDisplayedFileName] = useState<string>('');

  useEffect(() => {
    if (currentValue instanceof File) {
      setDisplayedFileName(currentValue.name);
    } else if (typeof currentValue === 'string' && currentValue) {
      const fileNameFromUrl = currentValue.substring(
        currentValue.lastIndexOf('/') + 1,
      );
      setDisplayedFileName(fileNameFromUrl);
    } else {
      setDisplayedFileName('');
    }
  }, [currentValue]);

  const handleFileChange = (files: FileList | null) => {
    const file = files && files.length > 0 ? files[0] : null;
    onChange(file);
  };

  return (
    <Box
      component="div"
      style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}
    >
      <Typography style={{ marginBottom: '4px' }}>{label}</Typography>
      <Paper
        component="div"
        elevation={0}
        style={{
          display: 'flex',
          alignItems: 'center',
          height: '40px',
          border: error
            ? `1px solid ${colors.error.red}`
            : `1px solid ${colors.primary.brightOrange}`,
          backgroundColor: colors.secondary.white,
          borderRadius: '4px',
          overflow: 'hidden',
          boxShadow: 'none',
        }}
      >
        <InputBase
          sx={{
            ml: 1,
            flex: 1,
            fontFamily: commons.fontFamily,
            color: colors.neutral.darkGray,
            '& input::placeholder': {
              color: colors.neutral.mediumGray,
              opacity: 1,
            },
          }}
          placeholder={placeholder}
          value={displayedFileName}
          readOnly
        />

        <FileInputButton
          label="Selecionar arquivo"
          onChange={handleFileChange}
          acceptedFileTypes={acceptedFileTypes}
        />
      </Paper>
      {helperText && (
        <Typography
          style={{
            color: error ? colors.error.red : colors.neutral.darkGray,
            fontSize: '0.75rem',
          }}
        >
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export default ImageUploadField;
